module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-61.f17201f8.svg";